var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pendo-page-content',[_c('guide-list-table',{attrs:{"type":"organization"},on:{"showGuideCreateChange":function($event){return _vm.$emit('showGuideCreateChange', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }